import { Profile } from '../../layout/profile/profile'
import { ProjectList } from '../../layout/projectList/list'
import './index.css'


export const ProjectsHome = ()=>{

    const data = [{name: 'UNFOLDIX', link: 'https://unfoldix.pages.dev', image: 'https://res.cloudinary.com/dhhtxax50/image/upload/v1737987267/logo1_ziqgfa.png', desc: 'Unfoldix web agency website. Build a landing page for your business in hours'},
                    {name: 'CarsForAll', link: 'https://larrysaam.github.io/CarDealership', image: 'https://res.cloudinary.com/dhhtxax50/image/upload/v1737323514/CarDealership/logo2_tymgoe.png', desc: 'List and sell any vehicle from your home. USE VPN TO ACCESS'}
                ]

    return(
        <div className='main'>
            <Profile/>
            <ProjectList data={data}/>
        </div>
    )
}